import { render, staticRenderFns } from "./info-affirm3.vue?vue&type=template&id=8934e7a0&scoped=true&"
import script from "./info-affirm3.vue?vue&type=script&lang=js&"
export * from "./info-affirm3.vue?vue&type=script&lang=js&"
import style0 from "./info-affirm3.vue?vue&type=style&index=0&id=8934e7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8934e7a0",
  null
  
)

export default component.exports